import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_WORKFLOW_COMPONENT_OBSERVER, TYPE_DATASOURCE } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI, ComponentDatasourceProvider } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';

export enum AGENDA_PLANNER_TYPE_PERIODE {
	CONSTANT = 'CONSTANT',
	WORKFLOW_FIELD = 'WORKFLOW_FIELD',
}
  
export interface AgendaPlannerModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
    datas: any[];
    valueField: string;
    displayField: string;
}
  
export class AgendaPlannerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'agenda_planner'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;
    datas: any[];
    valueField: string;
    displayField: string;

	constructor(config: AgendaPlannerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.KENDO;
        this.datas = config.datas;
        this.valueField = config.valueField;
        this.displayField = config.displayField;
		this.componentMode = config.componentMode;
	}

	static initModel(_component: Model_WorkflowComponent): AgendaPlannerModel {
		const _datasource = _component.UIC_PARAMS.DATASOURCE;
		const formModel = new AgendaPlannerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
            datas: !!_datasource ? _datasource.DATASOURCE_DATAS : [],
            valueField: !!_datasource ? _datasource.DATASOURCE_VALUE_FIELD : '',
            displayField: !!_datasource ? _datasource.DATASOURCE_DISPLAY_FIELD : '',
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		const workflowComponents = !!_options && !!_options.workflow ? Array.prototype.concat.apply([], _options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP })))) : [];

		return {
			ID: 'agenda_planner',
			CODE: CODE_WORKFLOW_COMPONENT.AGENDA_PLANNER,
			ICON: 'create-outline',
			LABEL: 'Planificateur',
			HAS_DATASOURCE: true,
			DATASOURCES_INFOS: [
				{
					DS_PROP_ID: 'NUM_DATASOURCE',
					DS_PROP_VALUE_COLUMN_ID: 'VALUE_COLUMN_NAME',
					DS_PROP_DISPLAY_COLUMN_ID: 'DISPLAY_COLUMN_NAME',
					DS_BUILD_NAME: 'DATASOURCE',
				},
				{
					DS_PROP_ID: 'NUM_DATASOURCE_AGENDA',
					DS_PROP_VALUE_COLUMN_ID: 'VALUE_COLUMN_NAME_AGENDA',
					DS_PROP_DISPLAY_COLUMN_ID: 'DISPLAY_COLUMN_NAME_AGENDA',
					DS_BUILD_NAME: 'DATASOURCE_AGENDA',
				},
			],
			CODE_SOCIETE: 'BLACK_HAWK_SECURITY',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ 
					ID: 'CODE_CLIENT', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Site', 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'AGENDA_PLANNER_TYPE_PERIODE', value: AGENDA_PLANNER_TYPE_PERIODE.WORKFLOW_FIELD }] }] 
				},
				{ ID: 'AGENDA_PLANNER_TYPE_PERIODE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Période', DEFAULT_VALUE: AGENDA_PLANNER_TYPE_PERIODE.CONSTANT, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: AGENDA_PLANNER_TYPE_PERIODE.CONSTANT, TEXT: 'Statique' }, 
								{ ID: AGENDA_PLANNER_TYPE_PERIODE.WORKFLOW_FIELD, TEXT: 'Champs du workflow' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ 
					ID: 'CONSTANT_DATE_DEBUT_PERIODE', 
					CODE: CODE_WORKFLOW_COMPONENT.DATEPICKER, 
					LABEL: 'Date Début', 
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'AGENDA_PLANNER_TYPE_PERIODE', value: AGENDA_PLANNER_TYPE_PERIODE.CONSTANT }] }] 
				},
				{ 
					ID: 'CONSTANT_DATE_FIN_PERIODE', 
					CODE: CODE_WORKFLOW_COMPONENT.DATEPICKER, 
					LABEL: 'Date Fin', 
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'AGENDA_PLANNER_TYPE_PERIODE', value: AGENDA_PLANNER_TYPE_PERIODE.CONSTANT }] }] 
				},
				{ 
					ID: 'WORKFLOW_FIELD_DATE_DEBUT_PERIODE', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Date début', 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'AGENDA_PLANNER_TYPE_PERIODE', value: AGENDA_PLANNER_TYPE_PERIODE.WORKFLOW_FIELD }] }] 
				},
				{ 
					ID: 'WORKFLOW_FIELD_DATE_FIN_PERIODE', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Date fin', 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					},
					RELATIONS: [{ match: MATCH_VISIBLE, when: [{ id: 'AGENDA_PLANNER_TYPE_PERIODE', value: AGENDA_PLANNER_TYPE_PERIODE.WORKFLOW_FIELD }] }] 
				},
                { ID: 'NUM_DATASOURCE', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Agents', IS_REQUIRED: true, HAS_DATASOURCE_FILTERS: false },
                { ID: 'VALUE_COLUMN_NAME', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne Valeur', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'DISPLAY_COLUMN_NAME', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne Affichage', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
                { ID: 'NUM_DATASOURCE_AGENDA', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Agenda', IS_REQUIRED: true, HAS_DATASOURCE_FILTERS: false },
			]
		};
	}
}
  